// Carte glass sombre : fond translucide sur primary-950, bordure subtile.
// Le chip d'icône utilise bg-white/8 pour ne pas créer de halo lumineux.
const FeatureCard = ({ icon, title, desc }) => (
  <div className="bg-white/[0.07] border border-white/15 shadow-[0_16px_40px_-20px_rgba(0,0,0,0.75)] hover:bg-white/[0.11] hover:border-white/30 hover:shadow-lift p-8 rounded-2xl transition-all duration-300 group">
    {/* Chip d'icône : teinte discrète, légère mise en avant au hover */}
    <div className="mb-6 p-4 bg-white/10 rounded-xl w-fit group-hover:scale-110 transition-transform duration-300">
      {icon}
    </div>
    <h3 className="font-display font-bold text-xl text-white mb-4">{title}</h3>
    <p className="font-sans text-sky/80 leading-relaxed text-sm">
      {desc}
    </p>
  </div>
);

export default FeatureCard;
